import { KK, VK } from '@/define/define'
import { BaseDevice, CustomLayout, DebounceTime, Dpi, initDpiRange } from '../base_device'
import board from '@/assets/img/device/he6_ultra/he6_ultra.png'
import { mouseVKCodes } from '../keyboard/keycode/vkeycode'
import { DeviceType } from '@libs/types/enum'

export class He6Ultra extends BaseDevice {
  name: string = 'HE6_Ultra'
  icon: string = board
  boardImage: string = board
  width: number = 207
  paddingX: number = 0
  paddingY: number = 0
  paddingBottom: number = 0
  texture = {}
  deviceType = DeviceType.mouse
  resetDes = ''
  // 不可操作
  inoperableKeys: KK[] = [0x0]
  lightEffectList: { [name: string]: number } = {
    关闭: 0,
    常亮_2: 1,
    呼吸_3: 2,
  }
  vkcodes = mouseVKCodes
  absoluteKey: CustomLayout = {
    0x01: this.createSquare(103, 0, 103, 193),
    0x02: this.createSquare(87, 43, 33, 66),
    0x04: this.createSquare(0, 118, 13, 59),
    0x03: this.createSquare(2, 165, 15, 59),
  }
  mouseClass: { [index: KK]: string } = {
    0x01: 'right',
    0x02: 'middle',
    0x04: 'forward',
    0x03: 'back',
  }
  speedAllowValues = [1, 2, 3, 4, 5]
  lightAllowValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  dpi: Dpi = {
    initList: [400, 800, 1600, 3200, 6400, 32000, 32000, 32000],
    initListColor: [
      [255, 0, 0],
      [0, 0, 255],
      [0, 255, 0],
      [255, 255, 0],
      [0, 255, 255],
      [255, 0, 255],
      [0, 255, 255],
      [194, 51, 255],
    ],
    length: 8,
    list: initDpiRange(),
    des: 'he2_dpi_des',
    isEdit: true,
    isColor: true,
  }
  rate: number[] = [0.125, 0.25, 0.5, 1, 2, 4, 8]
  debounceTime: DebounceTime = {
    max: 15,
    initValue: 8,
  }
  sleepTimeValues: number[] = [10, 30, 60, 120, 300, 600, 900]
  highPerformanceValues: number[] = [10, 30, 60, 120, 300, 600, 900]
}
